module.exports = __webpack_public_path__ + "static/img/fish13.6f261a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish13.png
// module id = /dDD
// module chunks = 0